import ArrowAnimation from "./ArrowAnimation";

export default ArrowAnimation;
